import { render, staticRenderFns } from "./tlzf.vue?vue&type=template&id=436e98d4&scoped=true"
import script from "./tlzf.vue?vue&type=script&lang=js"
export * from "./tlzf.vue?vue&type=script&lang=js"
import style0 from "./tlzf.vue?vue&type=style&index=0&id=436e98d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0__lodash_sniwsisxdvcgzet3yrvlfqnueq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436e98d4",
  null
  
)

export default component.exports